import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './zh-CN';
import enUS from './en-US';

const resources = {
  'zh-CN': {
    translation: zhCN,
  },
  'en-US': {
    translation: enUS,
  },
};

const getInitialLocale = () => {
  const cachedLanguage = localStorage.getItem('aspice_language');
  if (cachedLanguage) {
    return cachedLanguage;
  }
  const browserLang = navigator.language || navigator.languages?.[0] || 'zh-CN';
  if (browserLang.startsWith('en')) {
    return 'en-US';
  }
  return 'zh-CN';
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLocale(),
  fallbackLng: 'zh-CN',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
